import { render } from "./SearchResultsCard.vue?vue&type=template&id=771984e0&scoped=true"
import script from "./SearchResultsCard.vue?vue&type=script&lang=js"
export * from "./SearchResultsCard.vue?vue&type=script&lang=js"

import "./SearchResultsCard.vue?vue&type=style&index=0&id=771984e0&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-771984e0"]])

export default __exports__